export function getOverlayElementRoot(
  id: string,
  appendTo = document.getElementById('overlay-container') ?? document.body
) {
  const existingElement = document.querySelector(`#${id}`);
  if (existingElement) return existingElement;

  const newElement = document.createElement('div');
  newElement.setAttribute('id', id);
  appendTo.appendChild(newElement);

  return newElement;
}

/**
 * Focus the main content area of the application
 * Used for accessibility to return focus to the main content after navigation
 */
export function focusMain(): void {
  document.getElementById('main-content')?.focus();
}

export const findFirstFocusableElement = (container: HTMLDivElement): HTMLElement | undefined => {
  return Array.from(container.getElementsByTagName('*')).find(isFocusable);
};

const isFocusable = (item: Element): item is HTMLElement => {
  const element = item as HTMLElement;
  if (element.tabIndex < 0) {
    return false;
  }
  switch (element.tagName) {
    case 'A':
      return !!(element as HTMLAnchorElement)?.href;
    case 'INPUT':
      return (element as HTMLInputElement).type !== 'hidden' && !(element as HTMLInputElement).disabled;
    case 'SELECT':
    case 'TEXTAREA':
    case 'BUTTON':
      return !(element as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement).disabled;
    default:
      return false;
  }
};

export const focusElementByDataTest = (dataTest: string) => {
  const element = document.querySelector(`[data-test="${dataTest}"]`) as HTMLElement;
  element?.focus();
};

export function onCompleteFocusDataTest<T>(fun: () => Promise<T>, dataTest: string): () => Promise<T> {
  return () => fun().finally(() => focusElementByDataTest(dataTest));
}
